const integrations = {
	title: "Integrasjoner",
	stitle: "Integrasjon",
	new_integration: "Ny Integrasjon",
	edit_integration: "Integrasjon: {name}",
	list_title: "Integrasjoner",
	id: "ID",
	tenant_id: "Klient",
	name: "Navn",
	slug: "Tag",
	key: "Key",
	secret: "Secret",
	status: "Status",
	add_integration: "Velg Integrasjon",
	update_integration: "Oppdater Integrasjon",
};
export default integrations;